import { render, staticRenderFns } from "./AvukatList.vue?vue&type=template&id=c7823ce6"
import script from "./AvukatList.vue?vue&type=script&lang=ts"
export * from "./AvukatList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports